import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sex, fun and games",
  "description": "",
  "published": "2008-09-28T00:00:00.000Z",
  "redirect_from": ["/blog/sex-fun-and-games/swizec/65"],
  "categories": "food for thought, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`There are many expressions of love out there ranging from the single red rose to flamboyantly outrageous public performances to declare love in the most expensive and silliest of ways. Women love them all I believe, they care for the single rose because it's special and they love the big shebang because let's face it, for someone to go to all that trouble just to say they love you they must really love you.`}</p>
    <p>{`But in comparison to sex these are all just fun and games since there is no better way to express one's feelings towards someone than sex. Sex, although often enjoyed as a recrational activity, a sport even, is still one of the deepest and most profound means of establishing a connection it is, however, sadly also one of the simplest way to break said connection.`}</p>
    <p>{`So what could it mean when a person's partner all of a sudden, or perhaps gradually over time, begins refusing to have sex? Well it could just be that they're doing some very basic manipulation, but that'd be more of a one off thing rather than general refusal towards sexual activities. Which leads us to only one conclusion, they don't love you anymore.`}</p>
    <p>{`Let's face it, there is only one reason why anyone would refuse sex in general, they don't like it anymore. It may be a personal issue, or it may be that they like sex, just not with you. More often than not you'll also find that the "personal issue" suddenly gets resolved once they change their partner. All in all we can summize this paragraph by saying: they're refusing to have sex because there's no love anymore, or very little of it at least.`}</p>
    <p>{`If there is no more sex or there's just poor sex there isn't much a couple is to do but break up. They can still be friends perhaps, but why remain in a relationship where the other person doesn't even care so much for you as to have sex?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      